import React, { useState } from "react";
import "./AddChild.css";
import NavbarCustom from "../../Components/NavbarCustom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import UserView from "../../Components/BuyPackageAddChildCom/UserView";
import GuestView from "../../Components/BuyPackageAddChildCom/GuestView";



export const AddChild = () => {
  
  const user = JSON.parse(localStorage.getItem("user") || "null");
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");




  return (
    <>
      <NavbarCustom />

      <div className="buy-cart-sports-container buy-pckage-add-child">
        {/* Header */}
        <div className="buy-cart-header">
          <BackBtn />
          <div className="buy-cart-header-content">
            <h1 className="buy-cart-heading black-text-clip">Add Child Details</h1>
            <p className="black-text-clip">Please enter or choose your child</p>
          </div>
        </div>
          {user ? (
            <UserView packageID={id}/>
          ) : (
            <GuestView packageID={id}/>
          )}
      </div>
    </>
  );
};

export default AddChild;
